import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useAuthStore } from '@/stores/auth.store';

interface UserMeResponse {
  user: {
    id: string;
    email: string;
    name: string | null;
    avatar_url: string | null;
  };
  plan: string;
  relationships: Array<{
    id: string;
    creator_user_id: string;
    guest_user_id: string | null;
    invite_token: string;
    deleted_at: string | null;
    created_at: string;
  }>;
}

export function useUserMe() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  return useQuery({
    queryKey: queryKeys.user.me,
    queryFn: async () => {
      const response = await api.get('user/me').json<UserMeResponse>();
      return response;
    },
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}
